__turbopack_context__.v({
  "academyArticle": "xn86VG_academyArticle",
  "academyBackToHome": "xn86VG_academyBackToHome",
  "academyBackToHomeIcon": "xn86VG_academyBackToHomeIcon",
  "academyBackToHomeLabel": "xn86VG_academyBackToHomeLabel",
  "academyCategory": "xn86VG_academyCategory",
  "academyCategoryChevron": "xn86VG_academyCategoryChevron",
  "academyCategoryContent": "xn86VG_academyCategoryContent",
  "academyCategoryHeader": "xn86VG_academyCategoryHeader",
  "academyCategoryTitle": "xn86VG_academyCategoryTitle",
  "academyDocumentationChildren": "xn86VG_academyDocumentationChildren",
  "academyDocumentationSection": "xn86VG_academyDocumentationSection",
  "academyMainNavChevron": "xn86VG_academyMainNavChevron",
  "academyMainNavIcon": "xn86VG_academyMainNavIcon",
  "academyMainNavItem": "xn86VG_academyMainNavItem",
  "academyMainNavLabel": "xn86VG_academyMainNavLabel",
  "academyMainNavigation": "xn86VG_academyMainNavigation",
  "academyQuickStartList": "xn86VG_academyQuickStartList",
  "academyQuickStartProgress": "xn86VG_academyQuickStartProgress",
  "academyQuickStartProgressBar": "xn86VG_academyQuickStartProgressBar",
  "academyQuickStartProgressBarFill": "xn86VG_academyQuickStartProgressBarFill",
  "academyQuickStartProgressHeader": "xn86VG_academyQuickStartProgressHeader",
  "academyQuickStartProgressLabel": "xn86VG_academyQuickStartProgressLabel",
  "academyQuickStartProgressPercentage": "xn86VG_academyQuickStartProgressPercentage",
  "academyQuickStartProgressText": "xn86VG_academyQuickStartProgressText",
  "academySectionChildren": "xn86VG_academySectionChildren",
  "academySectionGroup": "xn86VG_academySectionGroup",
  "academySectionHeader": "xn86VG_academySectionHeader",
  "academySectionHeaderLabel": "xn86VG_academySectionHeaderLabel",
  "accountDrawer": "xn86VG_accountDrawer",
  "accountDrawerContent": "xn86VG_accountDrawerContent",
  "accountDrawerEmail": "xn86VG_accountDrawerEmail",
  "accountDrawerHeader": "xn86VG_accountDrawerHeader",
  "accountDrawerItem": "xn86VG_accountDrawerItem",
  "accountDrawerItemIcon": "xn86VG_accountDrawerItemIcon",
  "accountDrawerItemLabel": "xn86VG_accountDrawerItemLabel",
  "accountDrawerName": "xn86VG_accountDrawerName",
  "accountDrawerSeparator": "xn86VG_accountDrawerSeparator",
  "accountDrawerTitleSection": "xn86VG_accountDrawerTitleSection",
  "accountDrawerTitleText": "xn86VG_accountDrawerTitleText",
  "accountItem": "xn86VG_accountItem",
  "accountItemContent": "xn86VG_accountItemContent",
  "accountItemEmail": "xn86VG_accountItemEmail",
  "accountItemName": "xn86VG_accountItemName",
  "accountItemText": "xn86VG_accountItemText",
  "accountSection": "xn86VG_accountSection",
  "active": "xn86VG_active",
  "addNewButton": "xn86VG_addNewButton",
  "addNewDrawer": "xn86VG_addNewDrawer",
  "addNewDrawerContent": "xn86VG_addNewDrawerContent",
  "addNewDrawerItem": "xn86VG_addNewDrawerItem",
  "addNewDrawerItemIcon": "xn86VG_addNewDrawerItemIcon",
  "addNewDrawerItemLabel": "xn86VG_addNewDrawerItemLabel",
  "allLinksContainer": "xn86VG_allLinksContainer",
  "appHeader": "xn86VG_appHeader",
  "appHeaderContent": "xn86VG_appHeaderContent",
  "appHeaderIcon": "xn86VG_appHeaderIcon",
  "appHeaderLabel": "xn86VG_appHeaderLabel",
  "appPickerCheckmark": "xn86VG_appPickerCheckmark",
  "appPickerContent": "xn86VG_appPickerContent",
  "appPickerDivider": "xn86VG_appPickerDivider",
  "appPickerDragHandle": "xn86VG_appPickerDragHandle",
  "appPickerDrawer": "xn86VG_appPickerDrawer",
  "appPickerHeader": "xn86VG_appPickerHeader",
  "appPickerItem": "xn86VG_appPickerItem",
  "appPickerItemIcon": "xn86VG_appPickerItemIcon",
  "appPickerItemLabel": "xn86VG_appPickerItemLabel",
  "appPickerOverlay": "xn86VG_appPickerOverlay",
  "appPickerTitle": "xn86VG_appPickerTitle",
  "backButton": "xn86VG_backButton",
  "checkmark": "xn86VG_checkmark",
  "content": "xn86VG_content",
  "disabled": "xn86VG_disabled",
  "drawer": "xn86VG_drawer",
  "emptyMessage": "xn86VG_emptyMessage",
  "expanded": "xn86VG_expanded",
  "expandedItem": "xn86VG_expandedItem",
  "expandedItemLabel": "xn86VG_expandedItemLabel",
  "expandedList": "xn86VG_expandedList",
  "fadeIn": "xn86VG_fadeIn",
  "feedback": "xn86VG_feedback",
  "footer": "xn86VG_footer",
  "hasActive": "xn86VG_hasActive",
  "hasChildren": "xn86VG_hasChildren",
  "header": "xn86VG_header",
  "headerActions": "xn86VG_headerActions",
  "headerLogo": "xn86VG_headerLogo",
  "headerScrolled": "xn86VG_headerScrolled",
  "loading": "xn86VG_loading",
  "menuView": "xn86VG_menuView",
  "modulesDrawer": "xn86VG_modulesDrawer",
  "navGroup": "xn86VG_navGroup",
  "navGroupLabel": "xn86VG_navGroupLabel",
  "navItem": "xn86VG_navItem",
  "navItemBadge": "xn86VG_navItemBadge",
  "navItemIcon": "xn86VG_navItemIcon",
  "navItemLabel": "xn86VG_navItemLabel",
  "navItems": "xn86VG_navItems",
  "navigationSection": "xn86VG_navigationSection",
  "notificationBadge": "xn86VG_notificationBadge",
  "notificationBtn": "xn86VG_notificationBtn",
  "open": "xn86VG_open",
  "overlay": "xn86VG_overlay",
  "pickerEmptyMessage": "xn86VG_pickerEmptyMessage",
  "pickerSectionLabel": "xn86VG_pickerSectionLabel",
  "projectName": "xn86VG_projectName",
  "search": "xn86VG_search",
  "selected": "xn86VG_selected",
  "slideDown": "xn86VG_slideDown",
  "slideUp": "xn86VG_slideUp",
  "spin": "xn86VG_spin",
  "spinning": "xn86VG_spinning",
  "submenuGroup": "xn86VG_submenuGroup",
  "submenuGroupLabel": "xn86VG_submenuGroupLabel",
  "submenuItem": "xn86VG_submenuItem",
  "submenuItemIcon": "xn86VG_submenuItemIcon",
  "submenuSection": "xn86VG_submenuSection",
  "submenuSeparator": "xn86VG_submenuSeparator",
  "viewMain": "xn86VG_viewMain",
  "viewProjects": "xn86VG_viewProjects",
  "viewWorkspaces": "xn86VG_viewWorkspaces",
  "viewsContainer": "xn86VG_viewsContainer",
  "visionTree": "xn86VG_visionTree",
  "visionTreeContainer": "xn86VG_visionTreeContainer",
  "visionTreeNoResults": "xn86VG_visionTreeNoResults",
  "visionTreeNoResultsIcon": "xn86VG_visionTreeNoResultsIcon",
  "visionTreeNoResultsMessage": "xn86VG_visionTreeNoResultsMessage",
  "visionTreeNoResultsTitle": "xn86VG_visionTreeNoResultsTitle",
  "visionTreeSearch": "xn86VG_visionTreeSearch",
  "workspaceSelector": "xn86VG_workspaceSelector",
  "workspaceSelectorLabel": "xn86VG_workspaceSelectorLabel",
  "workspaceSelectorName": "xn86VG_workspaceSelectorName",
  "workspaceSelectorText": "xn86VG_workspaceSelectorText",
});
